module.exports = __webpack_public_path__ + "img/image-title2.11e67464.png";